module.exports = __webpack_public_path__ + "static/media/9DESA30.4819061e.jpg";